import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShoppingCart } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import { PRODUCT_ADD_TO_CART_FORM_ID } from '../../../product-page/components/ProductBuyBox/ProductAddToCartGroup/ProductAddToCartCta/ProductAddToCartCta'
import {
  EXPERIMENTS_TRACK_EVENT_STICKY_BUY_BOX,
  experimentsTrackEvent,
} from '../../eventTracking'

export const ExperimentStickyBuyBoxCta: FC<{ disableCta: boolean }> = ({
  disableCta,
}) => {
  const config = useGlobalConfigContext()

  return (
    <Button
      className="w-full"
      data-qa-id="add-to-cart-button"
      disabled={disableCta}
      form={PRODUCT_ADD_TO_CART_FORM_ID}
      onClick={() => {
        experimentsTrackEvent(config, EXPERIMENTS_TRACK_EVENT_STICKY_BUY_BOX)
      }}
      startIcon={<IconShoppingCart />}
      type="submit"
    >
      <FormattedMessage id="general.button.label.addToCart" />
    </Button>
  )
}
